// === FAQ ACCORDION ===
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.faq-q');
  if (!btn) return;
  const item = btn.parentElement;
  const answer = item.querySelector('.faq-a');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(el) {
    el.classList.remove('open');
    el.querySelector('.faq-a').hidden = true;
    el.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) {
    item.classList.add('open');
    answer.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  }
});

// === NAV SCROLL ===
const nav = document.getElementById('main-nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('scrolled', window.scrollY > 50);
}, { passive: true });

// === HAMBURGER MENU ===
const hamburger = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobile-menu');

hamburger.addEventListener('click', () => {
  const open = mobileMenu.classList.toggle('open');
  hamburger.classList.toggle('open', open);
  document.body.style.overflow = open ? 'hidden' : '';
});

document.querySelectorAll('.mob-link').forEach(link => {
  link.addEventListener('click', () => {
    mobileMenu.classList.remove('open');
    hamburger.classList.remove('open');
    document.body.style.overflow = '';
  });
});

// === QUOTE MODAL ===
const modal = document.getElementById('quote-modal');
const modalClose = document.getElementById('modal-close');
const typeBtns = document.querySelectorAll('.type-btn');
const jobTypeInput = document.getElementById('f-job-type');
const commercialFields = document.getElementById('commercial-fields');

function openModal(type) {
  if (!modal) return;
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
  if (type) {
    const btn = modal.querySelector(`.type-btn[data-type="${type}"]`);
    if (btn) btn.click();
  }
}

function closeModal() {
  if (!modal) return;
  modal.classList.remove('open');
  document.body.style.overflow = '';
}

// Open on any [data-open-modal] click — delegation so it works for
// dynamically rendered sections (Customize preview, lazy sections, etc.)
document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-open-modal]');
  if (!trigger) return;
  e.preventDefault();
  openModal(trigger.dataset.openModal);
});

// Close button
if (modalClose) modalClose.addEventListener('click', closeModal);

// Close on backdrop click (not panel click)
if (modal) {
  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal();
  });
}

// Close on Escape
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && modal && modal.classList.contains('open')) closeModal();
});

// === JOB TYPE TOGGLE ===
if (typeBtns.length) {
  typeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      typeBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const type = btn.dataset.type;
      if (jobTypeInput) jobTypeInput.value = type;
      if (commercialFields) {
        commercialFields.classList.toggle('visible', type === 'commercial');
      }
    });
  });
}

// === FORM BODY COMPILATION ===
const inquiryForm = document.getElementById('inquiry-form');

if (inquiryForm) {
  inquiryForm.addEventListener('submit', () => {
    const get = id => {
      const el = document.getElementById(id);
      return el ? el.value.trim() : '';
    };

    const jobType   = get('f-job-type') || 'residential';
    const address   = get('f-address');
    const suburb    = get('f-suburb');
    const state     = get('f-state');
    const postcode  = get('f-postcode');
    const bill      = get('f-bill');
    const solar     = get('f-existing-solar');
    const inverter  = get('f-inverter');
    const battery   = get('f-existing-battery');
    const blackout  = get('f-blackout');
    const sysSize   = get('f-system-size');
    const notes     = get('f-notes');
    const bizName   = get('f-business');
    const buildType = get('f-building');
    const gridConn  = get('f-grid');

    const line = (label, value) => value ? `${label}: ${value}\n` : '';

    let body = '';
    body += `JOB TYPE: ${jobType.toUpperCase()}\n`;
    body += '─'.repeat(40) + '\n\n';
    body += 'LOCATION\n';
    body += line('Address', address);
    body += line('Suburb', suburb);
    body += line('State', state);
    body += line('Postcode', postcode);
    body += '\nELECTRICITY\n';
    body += line('Monthly Bill', bill);
    body += '\nEXISTING SYSTEM\n';
    body += line('Solar', solar);
    body += line('Inverter Brand', inverter);
    body += line('Battery', battery);
    body += '\nREQUIREMENTS\n';
    body += line('System Size Interest', sysSize);
    body += line('Blackout Protection', blackout);

    if (jobType === 'commercial') {
      body += '\nCOMMERCIAL DETAILS\n';
      body += line('Business Name', bizName);
      body += line('Building Type', buildType);
      body += line('Grid Connection', gridConn);
    }

    if (notes) {
      body += '\nNOTES\n' + notes + '\n';
    }

    const compiledBody = document.getElementById('compiled-body');
    if (compiledBody) compiledBody.value = body;
  });
}
